import { useNavigate } from "react-router-dom";
import { ChevronDown, LogOut, UserCircle } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu";
import AlertBell from "./AlertBell";
import { useAuth } from "../store/auth";

const ROLE_LABELS = {
  owner: "Propietario",
  admin: "Administrador",
  compliance_manager: "Responsable de cumplimiento",
  auditor: "Auditor",
  member: "Miembro",
};

export default function Header() {
  const { user, organization, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/login", { replace: true });
  };

  return (
    <header
      data-testid="app-header"
      className="h-14 border-b border-slate-200 bg-white flex items-center justify-between px-6"
    >
      <div className="text-[14px] text-slate-500">
        {organization?.name && (
          <span data-testid="header-org-name">{organization.name}</span>
        )}
      </div>

      <div className="flex items-center gap-3">
        <AlertBell />
        <DropdownMenu>
        <DropdownMenuTrigger
          data-testid="header-user-menu"
          className="flex items-center gap-2 px-3 py-1.5 rounded-md hover:bg-slate-100 text-[14px]"
        >
          <div className="h-7 w-7 rounded-full bg-primary/10 text-primary flex items-center justify-center text-[12px] font-semibold">
            {user?.name?.[0]?.toUpperCase() || "?"}
          </div>
          <span className="text-slate-800">{user?.name}</span>
          <span className="text-slate-400 text-[12px]">
            · {ROLE_LABELS[user?.role] || user?.role}
          </span>
          <ChevronDown className="h-4 w-4 text-slate-500" />
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-56">
          <DropdownMenuLabel className="text-[12px] text-slate-500 font-normal">
            {user?.email}
          </DropdownMenuLabel>
          <DropdownMenuSeparator />
          <DropdownMenuItem
            data-testid="header-menu-profile"
            onClick={() => navigate("/settings/profile")}
          >
            <UserCircle className="h-4 w-4 mr-2" /> Mi perfil
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem
            data-testid="header-menu-logout"
            onClick={handleLogout}
            className="text-destructive focus:text-destructive"
          >
            <LogOut className="h-4 w-4 mr-2" /> Cerrar sesión
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      </div>
    </header>
  );
}
